// extracted by mini-css-extract-plugin
module.exports = {"image":"DSBJsxuZtbs1eD6NLZIS"};